import { useCallback, useEffect } from 'react';

import { subtitlesPosition } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Subtitles/Subtitles.types';

import { useSubtitlesSettingsSetters } from './use-subtitles';

export const useChangeSubtitlesPositionCallback = () => {
    const { setSubtitlesPosition } = useSubtitlesSettingsSetters();

    const changeSubtitlesPosition = useCallback(
        (hasOpenedPopup: boolean) =>
            setSubtitlesPosition?.(
                hasOpenedPopup ? subtitlesPosition.TOP : subtitlesPosition.BOTTOM
            ),
        [setSubtitlesPosition]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => () => changeSubtitlesPosition(false), []);

    return changeSubtitlesPosition;
};
